'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.composeArray = exports.intersects = undefined;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var intersects = exports.intersects = function intersects(arr1, arr2) {
  return _lodash2.default.intersection(arr1, arr2).length > 0;
};

var composeArray = exports.composeArray = function composeArray() {
  for (var _len = arguments.length, arrs = Array(_len), _key = 0; _key < _len; _key++) {
    arrs[_key] = arguments[_key];
  }

  var arr = [];

  arrs.forEach(function (o) {
    arr = [].concat(_toConsumableArray(arr), _toConsumableArray(o || []));
  });

  return arr;
};